import { Tabs, Tab, Stack } from "react-bootstrap";
import { actionSetErrorMessage, AppMessagesContext, SessionContext, SettingsManager } from "@viamap/viamap2-common";
import { MapitStateContext } from "src/states/MapitState";
import { LayerInfo, LayerType } from "src/common/managers/Types";
import { useContext, useEffect, useState } from "react";
import React from "react";
import { ADModalBody, AdvancedDragModal } from "src/componentsUtils/AdvancedDragModal";
import { GlassButton, GlassButtonRow } from "../../components/GlassButtons";

import { createPortal } from "react-dom";
import { ProtectedFeature } from "src/components/ProtectedFeature";
import { keyValueObject } from "src/components/SettingsEditor";
import { Feature } from "src/states/ApplicationStateFeatures";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { closeWindow, ManagedWindow, WindowId } from "src/WindowManager/WindowState";
import { FRPContext, initialize, selectProject, addProject, updateProject, loadProjects, deleteProject, FRPUserAccessRights, getMyAccessRights, FRPProject } from "./FRPState";
import { FRPProjectEditor } from "./FRPProjectEditor";
import { KeyValueTable } from "src/propertyInfoTemplates/PropertyComponents";
import { ConfirmationDialog } from "src/components/ConfirmationDialog";
import { ApplicationStateContext } from "src/states/ApplicationState";
import { FRPConst } from "./FRPConst";

type Props = {
  managedWindow: ManagedWindow;
  onFormClose: () => void;
};

export function FRPAdminDialog(props: Props) {
  const { state: frpState, dispatch: frpDispatch } = useContext(FRPContext);
  const { hasAccessToFeature } = useContext(ApplicationStateContext);
  const { state: sessionState } = useContext(SessionContext);
  const { dispatch: appMessageDispatch } = useContext(AppMessagesContext);
  const { dispatch: windowDispatch } = useWindowContext();

  const { state: mapitState } = React.useContext(MapitStateContext);
  const [availableLayers, setAvailableLayers] = useState<any>([]);
  const [selectedLayerId, setSelectedLayerId] = useState<number>();
  const [_projectId, setProjectId] = useState<string>();
  const [_projectName, setProjectName] = useState<string>();
  const [_esIndexName, setEsIndexName] = useState<string>();
  const [showProjectEditor, setShowProjectEditor] = useState<FRPProject | null>(null);
  const [newProject, setNewProject] = useState<boolean>(false);
  const [confirmDelete, setConfirmDelete] = useState<string | undefined>();
  const [emptyProject, setEmptyProject] = useState<FRPProject>({
    id: "",
    name: "",
    description: "",
    esIndexName: "",
    ownerUser: sessionState.userRef,
    ownerOrganization: sessionState.customerRef,
    settings: {},
    active: true,
    allowedUsersWithRoles: {},
    allowedOrganizationsWithRoles: {},
    protected: false
  });

  useEffect(() => {
    // Keep a list of available layers with Dgunr property
    let relevantLayers = Object.values(mapitState.layers)
      .filter((layerInfo: LayerInfo) => {
        return (layerInfo.propertiesInGeoJson?.map((prop) => (prop.toLowerCase().includes("lbnr") || prop.toLowerCase().includes("id")))) && ([LayerType.GeoJSON_Polygon, LayerType.GeoJSON_Point].includes(layerInfo.type));
      }
      );
    let relevantLayerKeys = relevantLayers.map((lr) => { return lr.layerId }).sort();
    let availableLayerKeys = availableLayers.map((lr) => { return lr.layerId }).sort();
    // only update if there are new layers - not on any (e.g. data or styling change)
    if (!(relevantLayerKeys + "" === availableLayerKeys + "")) {
      setAvailableLayers(relevantLayers);
      if (relevantLayers && relevantLayers.length > 0) {
        let found = relevantLayers.find((lr) => lr.layerId === selectedLayerId);
        if (!found) {
          // default to first available layer
          setSelectedLayerId(relevantLayers[0].layerId);
        }
      } else {
        setSelectedLayerId(undefined);
      }
    }
  }, [mapitState.layers]);

  useEffect(() => {
    // Load Projects State
    if (!frpState.isInitialized) {
      frpDispatch(initialize(SettingsManager.getSystemSetting("frp.projectsElasticIndex", ""), sessionState.userName));
    }
  }, [])

  useEffect(() => {

    setEmptyProject({
      id: "",
      name: "",
      description: "",
      esIndexName: "",
      ownerUser: sessionState.userRef,
      ownerOrganization: sessionState.customerRef,
      settings: {},
      active: true,
      allowedUsersWithRoles: { [sessionState.userRef]: [FRPUserAccessRights.Admin] },
      allowedOrganizationsWithRoles: {},
      protected: false
    })

  }, [sessionState.customerRef, sessionState.userRef])


  function filterProjectsByAccessRights(project: FRPProject): boolean {
    if (hasAccessToFeature(Feature.FRPToolGlobalAdmin)) {
      return true;
    };
    let accessRights = getMyAccessRights(project, sessionState.userRef, sessionState.customerRef);
    if (accessRights && accessRights.includes(FRPUserAccessRights.Admin)) {
      return true;
    }
    return false;
  }

  const ProjectsList = () => {

    return (
      <>
        <Stack gap={3}>
          {/* <h3>Projects. Selected = {bnboState.selectedProject ? bnboState.selectedProject.name : ""}</h3> */}
          <KeyValueTable>
            <tbody>
              <tr className="bold">
                <td>Id</td>
                <td>Project</td>
                <td>Protected</td>
                {/* <td>Status</td> */}
                {/* <td>Description</td> */}
                <td>ESIndexName</td>
                {/* <td>AllowedUserRoles</td>
                <td>Settings</td> */}
                <td>Actions</td>
              </tr>
              {(frpState.availableProjectsList || []).filter(filterProjectsByAccessRights).map((project, idx) => {
                return (
                  <tr key={project.id + idx}>
                    <td>{project.id}</td>
                    <td>{project.name}</td>
                    <td>{project.protected ? "yes" : ""}</td>
                    {/* <td>{project.active ? "active" : "inactive"}</td> */}
                    {/* <td>{project.description}</td> */}
                    <td>{project.esIndexName}</td>
                    {/* <td>{JSON.stringify(project.allowedUsersWithRoles)}</td>
                    <td>{JSON.stringify(project.settings)}</td> */}
                    <td>
                      <GlassButtonRow>
                        <GlassButton
                          onClick={() => {
                            windowDispatch(closeWindow(WindowId.BNBOSingleElement));
                            windowDispatch(closeWindow(WindowId.BNBOAreaEditor));
                            windowDispatch(closeWindow(WindowId.BNBOAreaViewer));
                            windowDispatch(closeWindow(WindowId.BNBOOpgørelse));
                            frpDispatch(selectProject(project.id));
                            let p = frpState.availableProjectsList?.find((a) => a.id === project.id);
                            if (p) {
                              setEsIndexName(p.esIndexName);
                              setProjectId(p.id);
                              setProjectName(p.name);
                            }
                          }}>Select</GlassButton>
                        <GlassButton
                          onClick={() => {
                            // Load projects in case any has changed by other user
                            frpDispatch(loadProjects((availableProjectsList: FRPProject[]) => {
                              setShowProjectEditor(availableProjectsList?.find((a) => a.id === project.id) || null);
                            }));
                          }}>Edit</GlassButton>
                        {!project.protected ? (
                          <GlassButton
                            onClick={() => {
                              setConfirmDelete(project.id)
                            }}>Delete
                          </GlassButton>
                        ) : null}
                      </GlassButtonRow>
                    </td>
                  </tr>
                )
              })
              }
            </tbody>
          </KeyValueTable>
        </Stack>
      </>
    )
  }

  const handleAddProject = async (projectId, project: FRPProject) => {
    if ((frpState.availableProjectsList || []).some((p) => p.id === projectId)) {
      appMessageDispatch(actionSetErrorMessage(`Project '${projectId}' already exists`));
      return;
    }

    let projectsElasticIndex = SettingsManager.getSystemSetting("frp.projectsElasticIndex", undefined);

    // Settings value for new project is default value from BNBOConst settings
    let defaultSettings = FRPConst.settings.reduce((acc, setting) => {
      acc[setting.key] = setting.default;
      return acc;
    }, {} as keyValueObject);
    let defaultValues: FRPProject = {
      ...project,
      esIndexName: projectsElasticIndex + "_" + projectId,
      ownerUser: "kbe@viamap.net",
      ownerOrganization: "viamap.net",
      settings: defaultSettings,
      active: true,
    }
    frpDispatch(addProject(projectId, defaultValues));
  }


  return (
    <AdvancedDragModal
      PosDefault={{ width: "1000px", left: "50%", transform: "translateX(-50%)", top: "1rem" }}
      title={"FRP Databaseadministration"}
      onClose={() => windowDispatch(closeWindow(WindowId.FRPAdminDialog))}
      window={props.managedWindow}
    >
      <ADModalBody>
        <Tabs defaultActiveKey={"FRPProjects"}>
          <Tab eventKey={"FRPProjects"} title={"Projekter"}>
            <ProtectedFeature feature={Feature.FRPToolAdmin}>
              <Stack gap={3}>
                <ProjectsList />
                <GlassButtonRow >
                  <GlassButton
                    onClick={() => {
                      frpDispatch(loadProjects());
                    }}>Load projects</GlassButton>
                  <GlassButton
                    onClick={() => {
                      setNewProject(true);
                    }}>New Project</GlassButton>
                </GlassButtonRow>
              </Stack>
            </ProtectedFeature>
          </Tab>
        </Tabs>
      </ADModalBody>
      {showProjectEditor ? createPortal(
        <FRPProjectEditor value={showProjectEditor} show={true} onClose={function (): void {
          setShowProjectEditor(null);
        }} onChange={function (project: FRPProject): void {
          frpDispatch(updateProject(project.id, project));
          setShowProjectEditor(null);
        }} />
        , document.getElementById("Mit-NonBlockingOverlay") || document.body) : null}
      {newProject ? createPortal(
        <FRPProjectEditor title="New Project" value={emptyProject} show={true} onClose={function (): void {
          setNewProject(false);
        }} onChange={function (project: FRPProject): void {
          handleAddProject(project.id, project);
          setNewProject(false);
        }} />
        , document.getElementById("Mit-NonBlockingOverlay") || document.body) : null}
      {confirmDelete ? createPortal(
        <ConfirmationDialog showWindow={1} header="Delete Project"
          onSubmit={() => {
            frpDispatch(deleteProject(confirmDelete));
            setConfirmDelete(undefined);
          }}
          onCancel={() => {
            setConfirmDelete(undefined);
          }} >
          <>
            Er du sikker på at du vil slette projektet {confirmDelete}?
          </>
        </ConfirmationDialog>
        , document.getElementById("Mit-NonBlockingOverlay") || document.body) : null}

    </AdvancedDragModal>
  )
}

